import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { openNewTab } from '@pocapan/shared/utils/UIUtils';
import { PopupFabButton } from '../../../components/fab/PopupFabButton';
import type { ArtistType } from '../../types/ArtistType';

export default function HomePopFabButton({
  selectedArtist
}: {
  selectedArtist: ArtistType | null;
}) {
  const navigate = useNavigate();
  const onClickFabButton = (index: number) => {
    if (index === 0) {
      openNewTab(`/report/select-member?artistId=${selectedArtist?.artistId}&reportType=photoCard`);
    } else if (index === 1) {
      navigate('/collections/select-method');
    }
  };

  return (
    <PopupFabButton
      buttonTexts={[
        t('CollectionsHomePage.ReportPhotoCardFabButton'),
        t('CollectionsHomePage.EditPhotoCardFabButton')
      ]}
      messageBubbleText={t('CollectionsHomePage.AddPhotoCardsBubbleMessage')}
      onClickFabChildrenButton={onClickFabButton}
    />
  );
}
